<template>
    <div class="user">
        <div class="photo">
            <img :src="$auth.user.picture" alt="avatar" />
        </div>
        <div class="user-info">


            <router-link to="/profile">
                <span>
                    {{ this.$auth.user.name }}
                </span>
            </router-link>


            <collapse-transition>
                <div v-show="!isClosed">
                    <ul class="nav">
                        <slot>
             
                        </slot>
                    </ul>
                </div>
            </collapse-transition>
        </div>
    </div>
</template>
<script>
    import { CollapseTransition } from "vue2-transitions";

    export default {
        components: {
            CollapseTransition
        },
        data() {
            return {
                isClosed: true
            };
        },
        methods: {
            logout() {
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            },
            clicked: function (e) {
                e.preventDefault();
            },
            toggleMenu: function () {
                this.isClosed = !this.isClosed;
            }
        }
    };
</script>
<style>
    .collapsed {
        transition: opacity 1s;
    }

    .user-info a {
        margin-left: 15px;
        margin-right: 15px;
        padding-top: 12px !important;
        padding-bottom: 12px !important;
        border-radius: 3px;
    }

        .user-info a:hover {
            background-color: rgba(200, 200, 200, 0.2);
        }

        .user-info a.router-link-active {
            background-color: #4caf50;
        }

    .sidebar .user .photo {
        margin-top: 3px;
    }
</style>
